
import {
  Activity,
  ArrowUpRightCircle,
  ArrowsAngleContract,
  CodeSlash,
  PersonPlus,
  Robot,
  type Icon,
} from "react-bootstrap-icons";

export interface AppConfig {
  apiUrl: string;
  appUrl: string;
  drawerWidth: number
}

export interface Certificate {
  name: string;
  image: string;
  link: string;
}

export type SkillTitleKey =
  | "softwareDev"
  | "digitalization"
  | "integration"
  | "migration"
  | "acceleratedAI"
  | "consultancy";

export type SkillDescriptionKey =
  | "softwareDevDesc"
  | "digitalizationDesc"
  | "integrationDesc"
  | "migrationDesc"
  | "acceleratedAIDesc"
  | "consultancyDesc";

export interface Skill {
  titleKey: SkillTitleKey;
  descriptionKey: SkillDescriptionKey;
  icon: Icon;
}

export const appConfig: AppConfig = {
  apiUrl: "/api",
  appUrl: typeof window === "undefined" ? "https://hasanuzun.de" : window.location.origin,
  drawerWidth: 240
};

export const skills: Skill[] = [
  {
    titleKey: "softwareDev",
    descriptionKey: "softwareDevDesc",
    icon: CodeSlash
  },
  {
    titleKey: "digitalization",
    descriptionKey: "digitalizationDesc",
    icon: Activity
  },
  {
    titleKey: "integration",
    descriptionKey: "integrationDesc",
    icon: ArrowsAngleContract
  },
  {
    titleKey: "migration",
    descriptionKey: "migrationDesc",
    icon: ArrowUpRightCircle
  },
  {
    titleKey: "acceleratedAI",
    descriptionKey: "acceleratedAIDesc",
    icon: Robot
  },
  {
    titleKey: "consultancy",
    descriptionKey: "consultancyDesc",
    icon: PersonPlus
  }
];

export const certificates: Certificate[] = [
  {
    name: "iSAQB® CPSA Foundation Level",
    image: "/cpsa-f-certified-badge.png",
    link: "https://www.certible.com/badge/3fb62c47-4309-4116-b9f5-573a2a32d351/"
  },
  {
    name: "Azure Solutions Architect Expert",
    image: "/azure-solutions-architect-expert.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/D42A06102E84172F?sharingId=932E4FB7366466D"
  },
  {
    name: "Azure Data Scientist Associate",
    image: "/azure-data-scientist-associate.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/68D4E1830CA8D28D?sharingId=932E4FB7366466D"
  },
  {
    name: "Azure Network Engineer Associate",
    image: "/az-700.jpeg",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/A9C2CCBC3FBBA30C?sharingId=932E4FB7366466D"
  },
  {
    name: "Security, Compliance, and Identity Fundamentals",
    image: "/SC-900.png",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/86743EF1B65C72CA?sharingId=932E4FB7366466D"
  },
  {
    name: "GitHub Copilot",
    image: "/github-copilot.svg",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/DFAA035E55BD0636?sharingId=932E4FB7366466D"
  },
  {
    name: "GitHub Administration",
    image: "/github-administration.svg",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/D37AB68E7122D554?sharingId=932E4FB7366466D"
  },
  {
    name: "GitHub Advanced Security",
    image: "/github-advanced-security.svg",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/F34219ABD0486A7E?sharingId=932E4FB7366466D"
  },
  {
    name: "GitHub Foundations",
    image: "/github-foundations.svg",
    link: "https://learn.microsoft.com/api/credentials/share/en-us/hasanuzun/2AC12B189F78CB61?sharingId=932E4FB7366466D"
  }
];

